"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Instruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const sol_kit_1 = require("@raindrop-studios/sol-kit");
const spl_token_1 = require("@solana/spl-token");
const programIds_1 = require("../constants/programIds");
const matches_1 = require("../state/matches");
const ata_1 = require("../utils/ata");
const pda_1 = require("../utils/pda");
class Instruction extends sol_kit_1.Instruction {
    constructor(args) {
        super(args);
    }
    async createMatch(args, _accounts = {}, _additionalArgs = {}) {
        const [match, _matchBump] = await pda_1.getMatch(args.winOracle);
        matches_1.transformTokenValidations(args);
        return {
            instructions: [
                await this.program.client.methods
                    .createMatch(args)
                    .accounts({
                    matchInstance: match,
                    payer: this.program.client.provider.wallet
                        .publicKey,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                })
                    .instruction(),
            ],
            signers: [],
        };
    }
    async disburseTokensByOracle(args, accounts, additionalArgs) {
        const match = (await pda_1.getMatch(accounts.winOracle))[0];
        const tfer = additionalArgs.tokenDelta;
        const [tokenAccountEscrow, _escrowBump] = await pda_1.getMatchTokenAccountEscrow(accounts.winOracle, tfer.mint, tfer.from);
        let destinationTokenAccount = tfer.to;
        const info = await this.program.client.provider.connection.getAccountInfo(destinationTokenAccount);
        const instructions = [];
        if (!info.owner.equals(programIds_1.TOKEN_PROGRAM_ID)) {
            const destinationTokenOwner = destinationTokenAccount;
            destinationTokenAccount = (await pda_1.getAtaForMint(tfer.mint, destinationTokenAccount))[0];
            const exists = await this.program.client.provider.connection.getAccountInfo(destinationTokenAccount);
            if (!exists || exists.data.length == 0) {
                instructions.unshift(ata_1.createAssociatedTokenAccountInstruction(destinationTokenAccount, this.program.client.provider.wallet.publicKey, destinationTokenOwner, tfer.mint));
            }
        }
        instructions.push(await this.program.client.methods
            .disburseTokensByOracle(args)
            .accounts({
            matchInstance: match,
            tokenAccountEscrow,
            tokenMint: tfer.mint,
            originalSender: tfer.from,
            destinationTokenAccount,
            winOracle: accounts.winOracle,
            tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
            systemProgram: anchor_1.web3.SystemProgram.programId,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        })
            .instruction());
        return {
            instructions,
            signers: [],
        };
    }
    async drainMatch(_args, accounts, additionalArgs) {
        const match = (await pda_1.getMatch(additionalArgs.winOracle))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .drainMatch()
                    .accounts({
                    matchInstance: match,
                    authority: this.program.client.provider.wallet
                        .publicKey,
                    receiver: accounts.receiver ||
                        this.program.client.provider.wallet.publicKey,
                })
                    .instruction(),
            ],
            signers: [],
        };
    }
    async drainOracle(args, accounts, _additionalArgs = {}) {
        const [oracle, oracleBump] = await pda_1.getOracle(new anchor_1.web3.PublicKey(args.seed), new anchor_1.web3.PublicKey(args.authority));
        const [match, _matchBump] = await pda_1.getMatch(oracle);
        return {
            instructions: [
                await this.program.client.methods
                    .drainOracle({ ...args, seed: new anchor_1.web3.PublicKey(args.seed) })
                    .accounts({
                    matchInstance: match,
                    authority: this.program.client.provider.wallet
                        .publicKey,
                    receiver: accounts.receiver ||
                        this.program.client.provider.wallet.publicKey,
                    oracle,
                })
                    .instruction(),
            ],
            signers: [],
        };
    }
    async updateMatch(args, accounts, _additionalArgs = {}) {
        const match = (await pda_1.getMatch(accounts.winOracle))[0];
        matches_1.transformTokenValidations(args);
        return {
            instructions: [
                await this.program.client.methods
                    .updateMatch(args)
                    .accounts({
                    matchInstance: match,
                    winOracle: accounts.winOracle,
                    authority: this.program.client.provider.wallet
                        .publicKey,
                })
                    .instruction(),
            ],
            signers: [],
        };
    }
    async leaveMatch(args, accounts, additionalArgs) {
        const match = (await pda_1.getMatch(additionalArgs.winOracle))[0];
        //const destinationTokenAccount = (
        //  await getAtaForMint(accounts.tokenMint, accounts.receiver)
        //)[0];
        const [tokenAccountEscrow, _escrowBump] = await pda_1.getMatchTokenAccountEscrow(additionalArgs.winOracle, accounts.tokenMint, this.program.client.provider.wallet.publicKey);
        const signers = [];
        return {
            instructions: [
                await this.program.client.methods
                    .leaveMatch(args)
                    .accounts({
                    matchInstance: match,
                    tokenAccountEscrow,
                    tokenMint: accounts.tokenMint,
                    destinationTokenAccount: accounts.receiver,
                    receiver: this.program.client.provider.wallet
                        .publicKey,
                    tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                })
                    .instruction(),
            ],
            signers,
        };
    }
    async joinMatch(args, accounts, additionalArgs) {
        const match = (await pda_1.getMatch(additionalArgs.winOracle))[0];
        const sourceTokenAccount = accounts.sourceTokenAccount ||
            (await pda_1.getAtaForMint(accounts.tokenMint, this.program.client.provider.wallet.publicKey))[0];
        const transferAuthority = accounts.tokenTransferAuthority || anchor_1.web3.Keypair.generate();
        const [tokenAccountEscrow, _escrowBump] = await pda_1.getMatchTokenAccountEscrow(additionalArgs.winOracle, accounts.tokenMint, this.program.client.provider.wallet.publicKey);
        const signers = [transferAuthority];
        return {
            instructions: [
                spl_token_1.Token.createApproveInstruction(programIds_1.TOKEN_PROGRAM_ID, sourceTokenAccount, transferAuthority.publicKey, this.program.client.provider.wallet.publicKey, [], args.amount.toNumber()),
                await this.program.client.methods
                    .joinMatch(args)
                    .accounts({
                    matchInstance: match,
                    tokenTransferAuthority: transferAuthority.publicKey,
                    tokenAccountEscrow,
                    tokenMint: accounts.tokenMint,
                    sourceTokenAccount,
                    sourceItemOrPlayerPda: additionalArgs.sourceType == matches_1.TokenType.Any
                        ? anchor_1.web3.SystemProgram.programId
                        : additionalArgs.sourceType == matches_1.TokenType.Item
                            ? (await pda_1.getItemPDA(accounts.tokenMint, additionalArgs.index))[0]
                            : (await pda_1.getPlayerPDA(accounts.tokenMint, additionalArgs.index))[0],
                    payer: this.program.client.provider.wallet
                        .publicKey,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                    validationProgram: accounts.validationProgram || anchor_1.web3.SystemProgram.programId,
                    tokenProgram: programIds_1.TOKEN_PROGRAM_ID,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                })
                    .signers(signers)
                    .instruction(),
                spl_token_1.Token.createRevokeInstruction(programIds_1.TOKEN_PROGRAM_ID, sourceTokenAccount, this.program.client.provider.wallet.publicKey, []),
            ],
            signers,
        };
    }
    async updateMatchFromOracle(args = {}, accounts, _additionalArgs = {}) {
        const match = (await pda_1.getMatch(accounts.winOracle))[0];
        return {
            instructions: [
                await this.program.client.methods
                    .updateMatchFromOracle()
                    .accounts({
                    matchInstance: match,
                    winOracle: accounts.winOracle,
                    authority: this.program.client.provider.wallet
                        .publicKey,
                    clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                })
                    .instruction(),
            ],
            signers: [],
        };
    }
    async createOrUpdateOracle(args, _accounts = {}, _additionalArgs = {}) {
        const [oracle, _oracleBump] = await pda_1.getOracle(new anchor_1.web3.PublicKey(args.seed), args.authority);
        const tokenTransfers = args.tokenTransfers
            ? args.tokenTransfers.map((t) => ({
                ...t,
                from: new anchor_1.web3.PublicKey(t.from),
                to: t.to ? new anchor_1.web3.PublicKey(t.to) : null,
                mint: new anchor_1.web3.PublicKey(t.mint),
                amount: new anchor_1.BN(t.amount),
            }))
            : null;
        return {
            instructions: [
                await this.program.client.methods
                    .createOrUpdateOracle({
                    ...args,
                    tokenTransfers,
                    seed: new anchor_1.web3.PublicKey(args.seed),
                })
                    .accounts({
                    oracle,
                    payer: this.program.client.provider.wallet
                        .publicKey,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                })
                    .instruction(),
            ],
            signers: [],
        };
    }
}
exports.Instruction = Instruction;
